import { defineComponent } from "vue";

export default defineComponent({
  name: "MCP",
  setup() {
    return () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        class="injected-svg"
        data-src="https://cdn.hugeicons.com/icons/mcp-server-solid-rounded.svg?v=2.0"
        role="img"
        color="currentColor"
      >
        <path
          d="M11.1074 2.73542C12.6101 1.37766 14.9306 1.4229 16.3788 2.87116C17.1707 3.6631 17.5431 4.71591 17.496 5.753C18.5335 5.70566 19.5867 6.079 20.3788 6.87116L20.5146 7.01472C21.8283 8.46908 21.8284 10.6884 20.5146 12.1426L20.3788 12.2852L13.414 19.2501L14.707 20.543L14.7753 20.6192C15.0956 21.012 15.073 21.591 14.707 21.9571C14.3409 22.3231 13.7618 22.3457 13.3691 22.0255L13.2929 21.9571L11.9999 20.6641C11.2191 19.8831 11.2191 18.617 11.9999 17.836L18.9648 10.8712L19.0898 10.7325C19.6365 10.0622 19.6364 9.0952 19.0898 8.42487L18.9648 8.28523C18.2954 7.61585 17.2356 7.57438 16.5175 8.16023L16.3788 8.28523L10.207 14.4571C9.81644 14.8476 9.18342 14.8476 8.7929 14.4571C8.40239 14.0666 8.40238 13.4336 8.7929 13.043L14.9648 6.87116L15.0898 6.73249C15.6756 6.01432 15.6342 4.95468 14.9648 4.28523C14.2954 3.61585 13.2356 3.57438 12.5175 4.16023L12.3788 4.28523L4.20697 12.4571C3.81644 12.8476 3.18343 12.8476 2.7929 12.4571C2.40239 12.0666 2.40238 11.4336 2.7929 11.043L10.9648 2.87116L11.1074 2.73542Z"
          fill="currentColor"
        ></path>
        <path
          d="M11.8925 16.764C10.3897 18.1217 8.06927 18.0765 6.621 16.6282C5.17276 15.1799 5.12759 12.8596 6.48526 11.3567L6.621 11.2142L12.7929 5.04229C13.1834 4.65177 13.8164 4.65177 14.2069 5.04229C14.5975 5.43282 14.5975 6.06583 14.2069 6.45635L8.03507 12.6282L7.91007 12.7669C7.3243 13.4851 7.36567 14.5447 8.03507 15.2142C8.70445 15.8836 9.76424 15.925 10.4823 15.3392L10.621 15.2142L16.7929 9.04229C17.1834 8.65176 17.8164 8.65177 18.2069 9.04229C18.5974 9.43282 18.5974 10.0659 18.2069 10.4564L12.0351 16.6282L11.8925 16.764Z"
          fill="currentColor"
        ></path>
      </svg>
    );
  },
});
